<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/04_Pollino/Itinerari-tematici/04-it_pollino_Cammino-Mazza.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Parco Nazionale del Pollino</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Parco Nazionale del Pollino</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Il Parco Nazionale del Pollino è dal 2015 Patrimonio Unesco per la biodiversità che caratterizza la sua flora e la sua fauna, 
            per i paesaggi incontaminati che si possono ammirare dalle cime che superano i 2000 metri s.l.m. e per la possibilità, 
            straordinaria di allargare lo sguardo fino ad entrambe le coste, quella del Mar Ionio che quella del Tirreno. Moltissime le specie arboree presenti, 
            tra cui il Pino Loricato simbolo del Parco, l’unico albero che sopravvive sulle vette dell’Appennino Calabro-Lucano, 
            così denominato per la corteccia che lo riveste, simile all’armatura dei guerrieri romani (lorica). Da un punto di vista faunistico, 
            l’area del Pollino è fra le più importanti di tutto il meridione d’Italia: fauna variegata, di cui fanno parte molte specie che si possono osservare soltanto qui, 
            come il nibbio reale o il gracchio corallino. Un ambiente prezioso da scoprire e da vivere attraverso le proprie passioni sportive o in sella a una bicicletta.
        </p>
    </div>
</div>
<br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-7 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Nazionale del Pollino.</p>
    </div>
    <div class="col-1 col-xl-1">
        <img src="../../../assets/images/04_Pollino/logo-pollino.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sui sentieri dei<br />"Patriarchi"</h1>
                        <a (click)="goToPatriarchi()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Lungo le strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goTo()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Alle origini<br />dell'avventura<br />umana</h1>
                        <a (click)="goToAvventuraUmana()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12 col-xl-3 four" id="four">
            <div class="card four">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Viaggio nella<br />cultura<br />arberëshe</h1>
                        <a (click)="goToCulturaArbereshe()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 five" id="five">
            <div class="card five">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Cammini di<br />spiritualità e<br />natura</h1>
                        <a (click)="goToSpiritualitaENatura()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 six" id="six">
            <div class="card six">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Percorsi<br />di gusto</h1>
                        <a (click)="goToPercorsiDiGusto()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>